var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('slider',_vm._b({staticClass:"vuestic-slider",attrs:{"value":_vm.value,"bg-style":_vm.sliderOptions.bgStyle,"slider-style":_vm.sliderOptions.sliderStyle},on:{"input":_vm.change}},'slider',_vm.sliderOptions,false))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e25bdd9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vuestic-theme/vuestic-components/vuestic-slider/VuesticSlider.vue
// module id = blA+
// module chunks = 79